// Preserve real shipping links as fallback; intercept only within product information.
if (!window.yehaProductInfoDialogsInstalled) {
 window.yehaProductInfoDialogsInstalled = true;
 document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const close = event.target.closest('[data-yeha-close-dialog]');
  if (close) { close.closest('dialog')?.close(); return; }
  const trigger = event.target.closest('[data-yeha-open-dialog]');
  if (trigger) {
   const dialog = document.getElementById(trigger.dataset.yehaOpenDialog);
   if (dialog instanceof HTMLDialogElement && !dialog.open) { event.preventDefault(); dialog.showModal(); }
   return;
  }
  const link = event.target.closest('.product-information a[href]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== '/policies/shipping-policy') return;
  const dialog = link.closest('.product-information')?.querySelector('.yeha-shipping-dialog');
  if (dialog instanceof HTMLDialogElement && !dialog.open) { event.preventDefault(); dialog.showModal(); }
 });
}
